import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('DIRECTORY_CONTACT')